import React, { useState } from 'react';
import { HexGrid, Layout, Hexagon, Pattern, Path, Hex } from 'react-hexgrid';
import { Link } from 'react-router-dom'; // Make sure you have react-router-dom installed


// Diana Barreiros Jorge 
// CDT BioDesign Engineering PhD student
// https://www.linkedin.com/in/diana-barreiros-jorge/

// Lobna ALOUI, Ph.D
// Digital Consultant | Industry 4.0| Project management| Chemistry | life science
//As an experienced scientific researcher with strong background in Chemistry and recent knowledge in computer and medicinal chemistry, I developed the required academic assets to tackle problems and manage scientific projects. Passionate about innovation, technologies, data analysis and the global strategy of project management, I'm motivated to overcome new challenges.
// https://www.linkedin.com/in/lobna-aloui-phd/


const data = {
  people: [
    {
      id: "asya-evloeva",
      name: "Asya Evloeva",
      position: "Founder",
      bio: "Data science, Machine Learning and Gen AI",
      image: "/assets/images/our-team/asya-evloeva.jpeg",
      url: "https://www.linkedin.com/in/asyaevloeva/"
    },
    {
      id: "hubert-nowak",
      name: "Hubert Nowak",
      position: "Marketing and PR",
      bio: "PR and Advertising",
      image: "/assets/images/our-team/hubert-nowak.jpg",
      url: "https://www.linkedin.com/in/hubert-nowak-2a77b51b8/"
    },
    {
      id: "foteini-mitsa",
      name: "Foteini Mitsa",
      position: "Cosmetic product analyst",
      bio: "Analytical Chemistry and Toxicology",
      image: "/assets/images/our-team/foteini-mitsa.jpeg",
      url: "https://www.linkedin.com/in/foteini-mitsa-b51b55128/"
    },
    {
      id: "cristiana-cozma",
      name: "Cristiana Cozma",
      position: "Marketing",
      bio: "Digital Marketing and Social Media Strategy",
      image: "/assets/images/our-team/cristiana-cozma.jpeg",
      url: "https://www.linkedin.com/in/cristiana-cozma-b24242145/"
    },
    {
      id: "charlotte-meersman",
      name: "Charlotte Meersman",
      position: "Legal Advisor",
      bio: "International corporate & Commercial law",
      image: "/assets/images/our-team/charlotte-meersman.jpeg",
      url: "https://www.linkedin.com/in/charlotte-m-4b58b91a6/"
    },
    {
      id: "eugenia-belousova",
      name: "Eugenia Belousova",
      position: "QA Tester",
      bio: "Quality Assurance Engineering",
      image: "/assets/images/our-team/eugenia-belousova.jpeg",
      url: "https://www.linkedin.com/in/eugenia-belousova/"
    }
  ]
};

const hexPositions = [
  { q: -2, r: 0, s: 1, id: 'asya-evloeva' },
  // { q: -2, r: 1, s: 0 }, // hex of asya
  { q: -1, r: 0, s: 1, id: 'hubert-nowak' },
  // { q: -1, r: 1, s: 0 }, // hex of hubert
  { q: 0, r: -1, s: 1, id: 'foteini-mitsa' },
  { q: 0, r: 0, s: 0, id: 'eugenia-belousova' },
  // { q: 0, r: 0, s: 0 }, // hex of foteini
  { q: 1, r: -1, s: 0, id: 'charlotte-meersman' },
  // { q: 1, r: 0, s: -1 }, // hex of charlotte 
  { q: 2, r: -2, s: 0, id: 'cristiana-cozma' },
  // { q: 2, r: -1, s: 0 }, // hex of cristiana
  // { q: 0, r: 1, s: 1, id: 'eugenia-belousova' },
  // { q: 0, r: 2, s: 0 }, // hex of eugenia
];

const hexSize = 10; // same as layout size.x and size.y


const HexGridComponent = () => {
  const [hoveredPersonId, setHoveredPersonId] = useState(null);
  const [selectedPersonId, setSelectedPersonId] = useState(null);

  const activePersonId = selectedPersonId || hoveredPersonId;
  const personToShow = data.people.find(p => p.id === activePersonId);

  return (
    <div className="flex flex-col items-center">

      {/* Info box always visible */}
      <div
        className="info-box mb-4 p-4 rounded shadow-md  max-w-l text-center"
        style={{
          background: 'linear-gradient(135deg, #CFC7DF 0%, #C58348 100%)',
          width: '100%',
          height: '250px',
          minWidth: '200px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          boxSizing: 'border-box',
        }}
      >
        {personToShow ? (
          <>
            <h3 className="font-bold text-[#2D1735] text-[40px]">{personToShow.name}</h3>
            <p className="text-[20px]  mb-2">{personToShow.position}</p>
            <p className="text-m">{personToShow.bio}</p>

            <div className="mt-4 w-full flex justify-center">
              <Link
                to={personToShow.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group border-2 border-[#5F40A1] rounded-[50px] px-8 py-4 cursor-pointer inline-block
               transition-colors duration-300 hover:border-[#7A6E62]"
              >
                <span className="text-[20px] text-[#5F40A1] group-hover:text-[#7A6E62] transition-colors duration-300">
                  Follow on linkedin
                </span>
              </Link>
            </div>
          </>
        ) : (
          <>
            <h3 className="font-bold text-[#2D1735] text-[40px]">Our Team</h3>
            <p className="text-[20px] text-[#2D1735]  mb-2">
              Meet the dedicated individuals who make our project possible. <br />We are a diverse group of professionals passionate about creating innovative solutions and providing excellent service.
            </p>

          </>
        )}
      </div>

      <HexGrid width="100%" height="100%" viewBox="-50 -30 100 40">
        <defs>
          <linearGradient id="default-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#CDC7DD" />
            <stop offset="100%" stopColor="#C58348" />
          </linearGradient>

          {/* Patterns for image hexes */}
          {data.people.map(person => (
            <Pattern key={person.id} id={person.id} link={person.image} />
          ))}
        </defs>

        <Layout size={{ x: 10, y: 10 }} flat spacing={1.2} origin={{ x: 0, y: 0 }}>
          {hexPositions.map(({ q, r, s, id }) => (
            <Hexagon
              key={`${q}-${r}-${s}`}
              className="hex-tile"
              q={q}
              r={r}
              s={s}
              fill={id || undefined}
              style={!id ? { fill: 'url(#default-gradient)' } : {}}
              onMouseEnter={() => id && setHoveredPersonId(id)}
              onMouseLeave={() => setHoveredPersonId(null)}
              onClick={() => id && setSelectedPersonId(id === selectedPersonId ? null : id)}
            />
          ))}
          <Path start={new Hex(0, 0, 0)} end={new Hex(-2, 0, 1)} />
        </Layout>
      </HexGrid>

      <style>{`
          .hex-tile {
            filter: brightness(0.9) saturate(0.9);
            transition: filter 0.3s ease;
            cursor: pointer;
          }
          .hex-tile:hover {
            filter: none;
          }
        `}</style>
    </div>
  );
};

export default HexGridComponent;

